import { useLayoutEffect, useRef } from "react";

/**
 * Pins the scroll container to the bottom when tracked values change.
 * Uses a sentinel + scrollIntoView after layout so cards/quick replies are measured.
 */
export function useScrollToBottom(
  messages,
  loading,
  bootLoading,
  enabled,
  extraKey = 0
) {
  const endRef = useRef(null);

  useLayoutEffect(() => {
    if (!enabled) return undefined;
    const el = endRef.current;
    if (!el) return undefined;
    const id = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.scrollIntoView({ behavior: "smooth", block: "end" });
      });
    });
    return () => cancelAnimationFrame(id);
  }, [enabled, messages, loading, bootLoading, extraKey]);

  return endRef;
}
